﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CmpShareX = exports.CmpUpVaultController = exports.CmpStabilityPool = exports.CmpBuyBurnPool = exports.CmpInternalExchanger = exports.CmpPriceKeeper = exports.CmpBlockContracts = exports.CmpBlockChart = exports.CmpBlockPools = exports.CmpBlockInternalExchangers = exports.CmpStatsItem = exports.CmpBlockStatsContainer = exports.CmpBlockUpManager = exports.CmpBlockUpToken = exports.CmpBlockPriceKeepers = exports.PageDashboard = exports.PageLoading = exports.TopNavBar = exports.ModalDialog = void 0;
const gs = require("@ivanlog/gs");
class ModalDialogControls {
    constructor(ctrls) {
        this._ctrls = ctrls;
        this.container = this._ctrls.get('container');
        this.content = this._ctrls.get('content');
        this.header = this._ctrls.get('header');
        this.textTitle = this._ctrls.get('textTitle');
        this.btnClose = this._ctrls.get('btnClose');
        this.body = this._ctrls.get('body');
        this.footer = this._ctrls.get('footer');
        this.btnOk = this._ctrls.get('btnOk');
        this.btnNo = this._ctrls.get('btnNo');
        this.btnCancel = this._ctrls.get('btnCancel');
    }
}
class ModalDialog extends gs.ComponentGS {
    constructor() {
        super("modalDialog", ModalDialogControls);
    }
}
exports.ModalDialog = ModalDialog;
class TopNavBarControls {
    constructor(ctrls) {
        this._ctrls = ctrls;
        this.label = this._ctrls.get('label');
    }
}
class TopNavBar extends gs.ComponentGS {
    constructor() {
        super("topNavBar", TopNavBarControls);
    }
}
exports.TopNavBar = TopNavBar;
class PageLoadingControls {
    constructor(ctrls) {
        this._ctrls = ctrls;
    }
}
class PageLoading extends gs.ComponentGS {
    constructor() {
        super("pageLoading", PageLoadingControls);
    }
}
exports.PageLoading = PageLoading;
class PageDashboardControls {
    constructor(ctrls) {
        this._ctrls = ctrls;
        this.blocks = this._ctrls.get('blocks');
    }
}
class PageDashboard extends gs.ComponentGS {
    constructor() {
        super("pageDashboard", PageDashboardControls);
    }
}
exports.PageDashboard = PageDashboard;
class CmpBlockPriceKeepersControls {
    constructor(ctrls) {
        this._ctrls = ctrls;
        this.blockPrices = this._ctrls.get('blockPrices');
    }
}
class CmpBlockPriceKeepers extends gs.ComponentGS {
    constructor() {
        super("cmpBlockPriceKeepers", CmpBlockPriceKeepersControls);
    }
}
exports.CmpBlockPriceKeepers = CmpBlockPriceKeepers;
class CmpBlockUpTokenControls {
    constructor(ctrls) {
        this._ctrls = ctrls;
        this.btnRefresh = this._ctrls.get('btnRefresh');
        this.lTotal = this._ctrls.get('lTotal');
        this.lBurned = this._ctrls.get('lBurned');
        this.iBurnValue = this._ctrls.get('iBurnValue');
        this.btnBurn = this._ctrls.get('btnBurn');
    }
}
class CmpBlockUpToken extends gs.ComponentGS {
    constructor() {
        super("cmpBlockUpToken", CmpBlockUpTokenControls);
    }
}
exports.CmpBlockUpToken = CmpBlockUpToken;
class CmpBlockUpManagerControls {
    constructor(ctrls) {
        this._ctrls = ctrls;
        this.imgLogo = this._ctrls.get('imgLogo');
        this.btnUpdate = this._ctrls.get('btnUpdate');
        this.btnUpdateSelectively = this._ctrls.get('btnUpdateSelectively');
        this.btnAdditional = this._ctrls.get('btnAdditional');
        this.lState = this._ctrls.get('lState');
        this.lAddress = this._ctrls.get('lAddress');
        this.blockAdditional = this._ctrls.get('blockAdditional');
        this.lBalance = this._ctrls.get('lBalance');
        this.lTokenLOAN = this._ctrls.get('lTokenLOAN');
        this.lTokenUSDL = this._ctrls.get('lTokenUSDL');
        this.lTokenUP = this._ctrls.get('lTokenUP');
        this.lLLVaultManager = this._ctrls.get('lLLVaultManager');
        this.lLLBorrower = this._ctrls.get('lLLBorrower');
        this.lLLStakePool = this._ctrls.get('lLLStakePool');
        this.lLLStabilityPool = this._ctrls.get('lLLStabilityPool');
        this.lTradeBot = this._ctrls.get('lTradeBot');
        this.lDelegatedSwapper = this._ctrls.get('lDelegatedSwapper');
        this.lRewardPool = this._ctrls.get('lRewardPool');
        this.lPriceKeeperPLS = this._ctrls.get('lPriceKeeperPLS');
        this.lPriceKeeperUP = this._ctrls.get('lPriceKeeperUP');
        this.lBuyBurnPool = this._ctrls.get('lBuyBurnPool');
        this.lStabilityPool = this._ctrls.get('lStabilityPool');
        this.lInternalExchangerBnB = this._ctrls.get('lInternalExchangerBnB');
        this.lInternalExchangerSP = this._ctrls.get('lInternalExchangerSP');
        this.lLiquidControllersDeployer = this._ctrls.get('lLiquidControllersDeployer');
        this.lVaults = this._ctrls.get('lVaults');
    }
}
class CmpBlockUpManager extends gs.ComponentGS {
    constructor() {
        super("cmpBlockUpManager", CmpBlockUpManagerControls);
    }
}
exports.CmpBlockUpManager = CmpBlockUpManager;
class CmpBlockStatsContainerControls {
    constructor(ctrls) {
        this._ctrls = ctrls;
        this.blockContainer = this._ctrls.get('blockContainer');
    }
}
class CmpBlockStatsContainer extends gs.ComponentGS {
    constructor() {
        super("cmpBlockStatsContainer", CmpBlockStatsContainerControls);
    }
}
exports.CmpBlockStatsContainer = CmpBlockStatsContainer;
class CmpStatsItemControls {
    constructor(ctrls) {
        this._ctrls = ctrls;
        this.lHeader = this._ctrls.get('lHeader');
        this.lText = this._ctrls.get('lText');
        this.lDescription = this._ctrls.get('lDescription');
    }
}
class CmpStatsItem extends gs.ComponentGS {
    constructor() {
        super("cmpStatsItem", CmpStatsItemControls);
    }
}
exports.CmpStatsItem = CmpStatsItem;
class CmpBlockInternalExchangersControls {
    constructor(ctrls) {
        this._ctrls = ctrls;
        this.blockExchangers = this._ctrls.get('blockExchangers');
    }
}
class CmpBlockInternalExchangers extends gs.ComponentGS {
    constructor() {
        super("cmpBlockInternalExchangers", CmpBlockInternalExchangersControls);
    }
}
exports.CmpBlockInternalExchangers = CmpBlockInternalExchangers;
class CmpBlockPoolsControls {
    constructor(ctrls) {
        this._ctrls = ctrls;
        this.blockPools = this._ctrls.get('blockPools');
    }
}
class CmpBlockPools extends gs.ComponentGS {
    constructor() {
        super("cmpBlockPools", CmpBlockPoolsControls);
    }
}
exports.CmpBlockPools = CmpBlockPools;
class CmpBlockChartControls {
    constructor(ctrls) {
        this._ctrls = ctrls;
        this.blockChart = this._ctrls.get('blockChart');
    }
}
class CmpBlockChart extends gs.ComponentGS {
    constructor() {
        super("cmpBlockChart", CmpBlockChartControls);
    }
}
exports.CmpBlockChart = CmpBlockChart;
class CmpBlockContractsControls {
    constructor(ctrls) {
        this._ctrls = ctrls;
        this.blockContainer = this._ctrls.get('blockContainer');
    }
}
class CmpBlockContracts extends gs.ComponentGS {
    constructor() {
        super("cmpBlockContracts", CmpBlockContractsControls);
    }
}
exports.CmpBlockContracts = CmpBlockContracts;
class CmpPriceKeeperControls {
    constructor(ctrls) {
        this._ctrls = ctrls;
        this.btnRefresh = this._ctrls.get('btnRefresh');
        this.btnInfo = this._ctrls.get('btnInfo');
        this.lFaqInfo = this._ctrls.get('lFaqInfo');
        this.lToken = this._ctrls.get('lToken');
        this.lPrice = this._ctrls.get('lPrice');
        this.lTokenAddress = this._ctrls.get('lTokenAddress');
    }
}
class CmpPriceKeeper extends gs.ComponentGS {
    constructor() {
        super("cmpPriceKeeper", CmpPriceKeeperControls);
    }
}
exports.CmpPriceKeeper = CmpPriceKeeper;
class CmpInternalExchangerControls {
    constructor(ctrls) {
        this._ctrls = ctrls;
        this.btnRefresh = this._ctrls.get('btnRefresh');
        this.btnInfo = this._ctrls.get('btnInfo');
        this.lFaqInfo = this._ctrls.get('lFaqInfo');
        this.lName = this._ctrls.get('lName');
        this.lBalancePLS = this._ctrls.get('lBalancePLS');
    }
}
class CmpInternalExchanger extends gs.ComponentGS {
    constructor() {
        super("cmpInternalExchanger", CmpInternalExchangerControls);
    }
}
exports.CmpInternalExchanger = CmpInternalExchanger;
class CmpBuyBurnPoolControls {
    constructor(ctrls) {
        this._ctrls = ctrls;
        this.btnRefresh = this._ctrls.get('btnRefresh');
        this.btnInfo = this._ctrls.get('btnInfo');
        this.lFaqInfo = this._ctrls.get('lFaqInfo');
        this.lBalancePLS = this._ctrls.get('lBalancePLS');
        this.lBalanceUSDL = this._ctrls.get('lBalanceUSDL');
        this.lBalanceLOAN = this._ctrls.get('lBalanceLOAN');
        this.lStakedUSDL = this._ctrls.get('lStakedUSDL');
        this.lStakedLOAN = this._ctrls.get('lStakedLOAN');
        this.lStabilityRewardLOAN = this._ctrls.get('lStabilityRewardLOAN');
        this.lStabilityRewardPLS = this._ctrls.get('lStabilityRewardPLS');
        this.lStakeRewardUSDL = this._ctrls.get('lStakeRewardUSDL');
        this.lStakeRewardPLS = this._ctrls.get('lStakeRewardPLS');
        this.lPriceATH = this._ctrls.get('lPriceATH');
        this.lForSwapUSDL = this._ctrls.get('lForSwapUSDL');
        this.lLastUpdateTime = this._ctrls.get('lLastUpdateTime');
        this.lPreBnBSeqTime = this._ctrls.get('lPreBnBSeqTime');
        this.lBotPriority = this._ctrls.get('lBotPriority');
        this.iValue = this._ctrls.get('iValue');
        this.btnDepositeUSDL = this._ctrls.get('btnDepositeUSDL');
        this.iValueLOAN = this._ctrls.get('iValueLOAN');
        this.btnDepositeLOAN = this._ctrls.get('btnDepositeLOAN');
        this.iValueUP = this._ctrls.get('iValueUP');
        this.btnDepositeUP = this._ctrls.get('btnDepositeUP');
        this.btnUpdate = this._ctrls.get('btnUpdate');
    }
}
class CmpBuyBurnPool extends gs.ComponentGS {
    constructor() {
        super("cmpBuyBurnPool", CmpBuyBurnPoolControls);
    }
}
exports.CmpBuyBurnPool = CmpBuyBurnPool;
class CmpStabilityPoolControls {
    constructor(ctrls) {
        this._ctrls = ctrls;
        this.btnRefresh = this._ctrls.get('btnRefresh');
        this.btnInfo = this._ctrls.get('btnInfo');
        this.lFaqInfo = this._ctrls.get('lFaqInfo');
        this.lBalancePLS = this._ctrls.get('lBalancePLS');
        this.lBalanceUSDL = this._ctrls.get('lBalanceUSDL');
        this.lBalanceLOAN = this._ctrls.get('lBalanceLOAN');
        this.lStakedUSDL = this._ctrls.get('lStakedUSDL');
        this.lStakedLOAN = this._ctrls.get('lStakedLOAN');
        this.lStabilityRewardLOAN = this._ctrls.get('lStabilityRewardLOAN');
        this.lStabilityRewardPLS = this._ctrls.get('lStabilityRewardPLS');
        this.lStakeRewardUSDL = this._ctrls.get('lStakeRewardUSDL');
        this.lStakeRewardPLS = this._ctrls.get('lStakeRewardPLS');
        this.lPricePLS_ATH = this._ctrls.get('lPricePLS_ATH');
        this.lInSwapMode = this._ctrls.get('lInSwapMode');
        this.lLastUpdateTime = this._ctrls.get('lLastUpdateTime');
        this.iValue = this._ctrls.get('iValue');
        this.btnDepositeUSDL = this._ctrls.get('btnDepositeUSDL');
        this.iValueLOAN = this._ctrls.get('iValueLOAN');
        this.btnDepositeLOAN = this._ctrls.get('btnDepositeLOAN');
        this.btnUpdate = this._ctrls.get('btnUpdate');
    }
}
class CmpStabilityPool extends gs.ComponentGS {
    constructor() {
        super("cmpStabilityPool", CmpStabilityPoolControls);
    }
}
exports.CmpStabilityPool = CmpStabilityPool;
class CmpUpVaultControllerControls {
    constructor(ctrls) {
        this._ctrls = ctrls;
        this.btnRefresh = this._ctrls.get('btnRefresh');
        this.btnInfo = this._ctrls.get('btnInfo');
        this.lFaqInfo = this._ctrls.get('lFaqInfo');
        this.lLabel = this._ctrls.get('lLabel');
        this.lStatus = this._ctrls.get('lStatus');
        this.lBalance = this._ctrls.get('lBalance');
        this.lBalanceUSDL = this._ctrls.get('lBalanceUSDL');
        this.lICR = this._ctrls.get('lICR');
        this.lDebt = this._ctrls.get('lDebt');
        this.lColl = this._ctrls.get('lColl');
        this.lTargetICR = this._ctrls.get('lTargetICR');
        this.lTargetReloanICR = this._ctrls.get('lTargetReloanICR');
        this.lllMinLoan = this._ctrls.get('lllMinLoan');
        this.lllGas = this._ctrls.get('lllGas');
        this.lLoanMinReTakeUSDL = this._ctrls.get('lLoanMinReTakeUSDL');
        this.lSwapMinUSDL = this._ctrls.get('lSwapMinUSDL');
        this.lMaxLoanDumpIndex = this._ctrls.get('lMaxLoanDumpIndex');
        this.lStabPoolSplitPartRever = this._ctrls.get('lStabPoolSplitPartRever');
        this.lBuyBurnSplitPartRevers = this._ctrls.get('lBuyBurnSplitPartRevers');
        this.iValueUSDL = this._ctrls.get('iValueUSDL');
        this.btnDepositeUSDL = this._ctrls.get('btnDepositeUSDL');
        this.iValuePLS = this._ctrls.get('iValuePLS');
        this.btnDepositePLS = this._ctrls.get('btnDepositePLS');
        this.btnUpdate = this._ctrls.get('btnUpdate');
    }
}
class CmpUpVaultController extends gs.ComponentGS {
    constructor() {
        super("cmpUpVaultController", CmpUpVaultControllerControls);
    }
}
exports.CmpUpVaultController = CmpUpVaultController;
class CmpShareXControls {
    constructor(ctrls) {
        this._ctrls = ctrls;
        this.btnRefresh = this._ctrls.get('btnRefresh');
        this.btnInfo = this._ctrls.get('btnInfo');
        this.lFaqInfo = this._ctrls.get('lFaqInfo');
        this.lName = this._ctrls.get('lName');
        this.lTotalSupply = this._ctrls.get('lTotalSupply');
        this.lBalancePLS = this._ctrls.get('lBalancePLS');
        this.lBalanceUSDL = this._ctrls.get('lBalanceUSDL');
        this.lNeedConsumePLS = this._ctrls.get('lNeedConsumePLS');
        this.lNeedConsumeUSDL = this._ctrls.get('lNeedConsumeUSDL');
        this.lShare = this._ctrls.get('lShare');
        this.lRewardPLS = this._ctrls.get('lRewardPLS');
        this.lRewardUSDL = this._ctrls.get('lRewardUSDL');
        this.iValueUSDL = this._ctrls.get('iValueUSDL');
        this.btnDepositeUSDL = this._ctrls.get('btnDepositeUSDL');
        this.iValuePLS = this._ctrls.get('iValuePLS');
        this.btnDepositePLS = this._ctrls.get('btnDepositePLS');
        this.btnConsumePLS = this._ctrls.get('btnConsumePLS');
        this.btnConsumeUSDL = this._ctrls.get('btnConsumeUSDL');
        this.btnWithdrawPLS = this._ctrls.get('btnWithdrawPLS');
        this.btnWithdrawUSDL = this._ctrls.get('btnWithdrawUSDL');
    }
}
class CmpShareX extends gs.ComponentGS {
    constructor() {
        super("cmpShareX", CmpShareXControls);
    }
}
exports.CmpShareX = CmpShareX;
gs.WrapperGS.InjectComponents(ModalDialog, 'ModalDialog');
gs.WrapperGS.InjectComponents(TopNavBar, 'TopNavBar');
gs.WrapperGS.InjectComponents(PageLoading, 'PageLoading');
gs.WrapperGS.InjectComponents(PageDashboard, 'PageDashboard');
gs.WrapperGS.InjectComponents(CmpBlockPriceKeepers, 'CmpBlockPriceKeepers');
gs.WrapperGS.InjectComponents(CmpBlockUpToken, 'CmpBlockUpToken');
gs.WrapperGS.InjectComponents(CmpBlockUpManager, 'CmpBlockUpManager');
gs.WrapperGS.InjectComponents(CmpBlockStatsContainer, 'CmpBlockStatsContainer');
gs.WrapperGS.InjectComponents(CmpStatsItem, 'CmpStatsItem');
gs.WrapperGS.InjectComponents(CmpBlockInternalExchangers, 'CmpBlockInternalExchangers');
gs.WrapperGS.InjectComponents(CmpBlockPools, 'CmpBlockPools');
gs.WrapperGS.InjectComponents(CmpBlockChart, 'CmpBlockChart');
gs.WrapperGS.InjectComponents(CmpBlockContracts, 'CmpBlockContracts');
gs.WrapperGS.InjectComponents(CmpPriceKeeper, 'CmpPriceKeeper');
gs.WrapperGS.InjectComponents(CmpInternalExchanger, 'CmpInternalExchanger');
gs.WrapperGS.InjectComponents(CmpBuyBurnPool, 'CmpBuyBurnPool');
gs.WrapperGS.InjectComponents(CmpStabilityPool, 'CmpStabilityPool');
gs.WrapperGS.InjectComponents(CmpUpVaultController, 'CmpUpVaultController');
gs.WrapperGS.InjectComponents(CmpShareX, 'CmpShareX');
//# sourceMappingURL=tmpls.js.map